import $ from 'jquery';
import debounce from './utils/debounce';

class MobileMenu {
    constructor(hamburgerClass, mainMenuClass, menuItemExpand, subNavClass) {
        this.$body = $('body');
        this.$mainMenu = $(mainMenuClass);
        this.$hamburger = $(hamburgerClass);
        this.$menuItemExpand = $(menuItemExpand);
        this.$subNav = $(subNavClass);
        this.$window = $(window);

        this.$hamburger.on('click', $.proxy(this.toggleMenu, this));
        this.$menuItemExpand.on('click', $.proxy(this.toggleSubNav, this));

        this.$window.on('load resize', debounce(() => {
            if ($(window).width() >= 767) {
                this.resetMenu();
                this.$body.removeClass('has-mobile-menu');
            } else {
                this.$body.addClass('has-mobile-menu');
            }
        }));

        this.$window.on('search-mobile-open', () => {
            this.$hamburger.removeClass('is-cross');
            this.$mainMenu.removeClass('is-visible');
        });
    }

    toggleMenu(e) {
        const $elem = $(e.currentTarget);

        this.$mainMenu.toggleClass('is-visible');
        this.$hamburger.toggleClass('is-cross');
        this.$body.toggleClass('is-fixed');

        if (this.$mainMenu.hasClass('is-visible')) {
            this.$window.trigger('mobile-menu-open');
        }
    }

    toggleSubNav(e) {
        const $elem = $(e.currentTarget);

        if (this.$body.hasClass('has-mobile-menu')) {
            if (!$elem.hasClass('is-clicked')) {
                this.closeAllSubNavs();
                this.openSubNav($elem);
            } else {
                this.closeSubNav($elem);
            }
        }
    }

    openSubNav($elem) {
        $elem.addClass('is-clicked');
        $elem.parent().addClass('is-open');

        $elem.next('.js-sub-menu').slideDown('swing');
    }

    closeSubNav($elem) {
        $elem.removeClass('is-clicked');
        $elem.parent().removeClass('is-open');

        $elem.next('.js-sub-menu').slideUp('swing');
    }

    closeAllSubNavs() {
        this.$menuItemExpand.removeClass('is-clicked');
        this.$menuItemExpand.parent().removeClass('is-open');

        this.$subNav.slideUp('swing');
    }

    resetMenu() {
        this.$mainMenu.removeClass('is-visible');
        this.$hamburger.removeClass('is-cross');
        this.$body.removeClass('is-fixed');
        this.$subNav.removeAttr('style');
    }
}

export default MobileMenu;
